export default __webpack_public_path__ + "static/media/1430.8688d30b.png";